/**
 * quota.js  — student-facing language only. Zero "credit" mention.
 * Backend still uses credits internally; this file is display-only.
 */

// ── Free tier ──────────────────────────────────────────────────────
export const FREE_QUOTA = {
  mcq:          { label: "MCQs",          limit: 50, creditCost: 1 },   // not live yet
  short_answer: { label: "Short answers", limit: 4,  creditCost: 2 },
  short_essay:  { label: "Short essays",  limit: 2,  creditCost: 4 },
  long_essay:   { label: "Long essays",   limit: 1,  creditCost: 4 },
};

// ── ONE paid plan (PKG_SEMESTER) ────────────────────────────────────
export const PAID_PLAN = {
  pkg_id:    "PKG_SEMESTER",
  name:      "Semester Plan",
  price_inr: 999,
  badge:     "Full access",
  headline:  "Unlimited practice for the semester",
  includes: [
    "Unlimited short answers",
    "Unlimited short essays",
    "Unlimited long essays",
    "Detailed AI feedback on every answer",
    "Weak topic tracking",
    "Full dashboard & progress report",
  ],
  note: "One-time payment · No expiry until exams",
};

// ── Derive remaining question counts from credits_remaining ─────────
export function getQuotaFromCredits(cr = 0) {
  return {
    mcq:          Math.min(FREE_QUOTA.mcq.limit,          Math.floor(cr / FREE_QUOTA.mcq.creditCost)),
    short_answer: Math.min(FREE_QUOTA.short_answer.limit, Math.floor(cr / FREE_QUOTA.short_answer.creditCost)),
    short_essay:  Math.min(FREE_QUOTA.short_essay.limit,  Math.floor(cr / FREE_QUOTA.short_essay.creditCost)),
    long_essay:   Math.min(FREE_QUOTA.long_essay.limit,   Math.floor(cr / FREE_QUOTA.long_essay.creditCost)),
  };
}

export function getQuotaExhaustedMessage(questionType) {
  return {
    short_answer: "You've used your 4 free short answers this month.",
    short_essay:  "You've used your 2 free short essays this month.",
    long_essay:   "You've used your free long essay this month.",
    mcq:          "You've used your 50 free MCQs this month.",
  }[questionType] ?? "You've reached your free limit for this month.";
}

export const RESET_PERIOD_LABEL = "Resets in 30 days";
